import { useMemo } from "react";
import styles from "./GoogleSearchConsoleViewer.module.css";
import {
  IndexingViewer,
  SitePerformanceViewer,
  GscReportViewer,
} from "../assessmentViewer/FoundationStage";
import { GSC_TAB_CONFIG } from "./GscTabConfig";

const asText = (value) => {
  if (typeof value === "string") return value.trim();
  if (value && typeof value === "object" && typeof value.text === "string") {
    return value.text.trim();
  }
  return "";
};

const renderSection = (key, text) => {
  if (!text) return null;
  if (key === "indexing") return <IndexingViewer markdown={text} />;
  if (key === "core_web_vitals")
    return <SitePerformanceViewer markdown={text} />;
  if (key === "performance") return <GscReportViewer markdown={text} />;
  return null;
};

const GoogleSearchConsoleViewer = ({ data = {}, activeTab = "indexing" }) => {
  const summary = asText(data?.summary);
  const sections = useMemo(
    () =>
      GSC_TAB_CONFIG.map((tab) => {
        const text = asText(data?.[tab.key]);
        return {
          ...tab,
          text,
          content: renderSection(tab.key, text),
        };
      }).filter((tab) => Boolean(tab.text)),
    [data],
  );

  const active = sections.find((section) => section.key === activeTab) || null;

  if (!active) {
    return (
      <div className={styles.container}>
        <p className={styles.emptyState}>No Google Search Console data yet.</p>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      {summary ? (
        <div className={styles.summaryCard}>
          <p className={styles.summaryLabel}>Report Summary</p>
          <p className={styles.summaryText}>{summary}</p>
        </div>
      ) : null}
      <div className={styles.sectionWrap}>{active.content}</div>
    </div>
  );
};

export default GoogleSearchConsoleViewer;
